import { Component, OnDestroy } from "@angular/core";
import { AtlasCustomControlComponent } from "@asfinag/atlas/map";
import * as L from "leaflet";
import { Subscription } from "rxjs";

import { getCurrentGeolocation } from "../../utils/current-location";

/** The payload for the SetPositionBtnComponent */
export interface SetPositionBtnComponentPayload {
	map: L.Map;
	/**
	 * Position to set the current view of the map to.
	 * Can either be supplied via the getCurrentGeolocation function or directly via a LatLng or LatLngBounds expression.
	 */
	position: typeof getCurrentGeolocation | L.LatLng | L.LatLngBounds;
}

/**
 * Custom control component for a leaflet map, which sets the view of the map to the value of the provided position.
 */
@Component({
	selector: "dr-set-position-btn",
	templateUrl: "./set-position-btn.component.html",
})
export class SetPositionBtnComponent extends AtlasCustomControlComponent<SetPositionBtnComponentPayload> implements OnDestroy {
	private readonly subscriptions: Subscription[] = [];

	constructor() {
		super();
	}

	public onBtnClicked(): void {
		// if position is supplied by the current geolocation function
		if (typeof this.payload?.position === "function") {
			this.subscriptions.push(
				this.payload.position().subscribe((position) => {
					this.payload?.map.setView([position.coords.latitude, position.coords.longitude]);
				}),
			);
		} else if (this.payload?.position instanceof L.LatLng) {
			this.payload?.map.setView(this.payload?.position);
		} else if (this.payload?.position instanceof L.LatLngBounds) {
			this.payload?.map?.fitBounds(this.payload?.position, { padding: [25, 60] });
		}
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
